import React, { FC } from "react";

import { useImportContext } from "../importContext";
import { ExcelImportSteps } from "./ExcelImportSteps";
import { ImportFile } from "./ImportFile";
import { KMLImportSteps } from "./KMLImportSteps";
import { ShapeImportSteps } from "./ShapeImportSteps";
import { GDBImportSteps } from "./GDBImportSteps";
import { ImportType } from "../types";

export const ImportSteps: FC = () => {
  const { step, importType } = useImportContext();

  if (step === 0) {
    return <ImportFile />;
  }

  switch (importType) {
    case ImportType.KML:
      return <KMLImportSteps />;
    case ImportType.XLSX:
      return <ExcelImportSteps />;
    case ImportType.SHAPE:
      return <ShapeImportSteps />;
    case ImportType.GDB:
      return <GDBImportSteps />;
    default:
      return <ImportFile />;
  }
};
